ApiError = require 'app/scripts/network/api-error'
Hearsay = require 'hearsay'
Promise = require 'bluebird'
moment = require 'moment'
f = require 'effing'
assert = require 'app/scripts/lib/assert'
customError = require '@atlassian/trello-error-ext'

PollingError = customError('PollingError')

module.exports = class Pollster
  _started: false

  constructor: (@pollFx, @minutesToPoll, @intervalMs) ->
    @_protectedState = new Hearsay.Slot({})
    @state = @_protectedState
    @finished = new Promise (resolve) =>
      @_resolveFinished = resolve

    unuse = @_protectedState.use()
    @finished.finally unuse

  start: ->
    assert !@_started, "Cannot start more than once!"
    assert !@_isComplete(), "Cannot start after stopping!"
    @_started = true
    @_dateToStopPolling = moment().add(@minutesToPoll, 'minutes').toDate()
    @_poll()
    return

  _done: ->
    assert !@_isComplete(), "Pollster cannot complete more than once!"
    @_resolveFinished @state.get()

  _isComplete: ->
    @finished.isFulfilled()

  stop: ->
    if @_isComplete()
      return

    if @_currentTimeout?
      clearTimeout @_currentTimeout
      delete @_currentTimeout

    @_done()
    return

  _poll: ->
    Promise.try @pollFx
    .catch (error) -> Promise.reject PollingError('', { innerError: error })
    .then (value) =>
      if @_isComplete()
        return

      @_protectedState.set { value }

      if moment().isBefore(@_dateToStopPolling)
        @_currentTimeout = setTimeout f(@, '_poll'), @intervalMs
      else
        @_protectedState.set { timeout: true }
        delete @_currentTimeout
        @_done()
      return
    .catch PollingError, ({ innerError }) =>
      @_protectedState.set { error: innerError }
      @_done()
    .done()
